<template lang="pug">
div
  div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('post_appointment_instruction_optional') }}
  div.text-sm.neutral500--text {{ $t('post_appointment_instruction_desc') }}

  v-row.pb-3(no-gutters)
    v-col(cols="12" sm="6")
      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('label_title_of_instruction') }}
      v-text-field.text-md.font-normal.mt-2.round-xl(v-model="label" :placeholder="$t('after_appointment')" outlined :rules="instructions ? rules.not_empty : []" dense height="48" hide-details="auto" :disabled="disabled")

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('post_appointment_instruction') }}
      v-textarea.text-md.font-normal.mt-2.round-xl(v-model="instructions" :placeholder="$t('post_appointment_instruction_placeholder')" outlined :rules="label ? rules.not_empty : []" dense hide-details="auto" :disabled="disabled")
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServicePostInstructions',
  components: {  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      label: null,
      instructions: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
    }),
    instructionData () {
      return {
        post_appointment: {
          label: this.label,
          instructions: this.instructions,
        }
      }
    }
  },
  watch: {
    instructionData: {
      deep: true,
      handler (val) {
        if (this.disabled) return
        this.$store.commit('clinic/updateTempService', val)
      }
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      if (service.instructions.post_appointment) {
        this.label = service.instructions.post_appointment.label
        this.instructions = service.instructions.post_appointment.instructions
      }
    },
  }
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.inputText >>> input {
  margin-top: 3px;
  text-align: center;
}
</style>